import { useEffect, useState, useRef } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import atoms from "../../atoms";
import constant from "../../../constants/constant";
import CopyIcon from "../../../assets/Images/copy-icon.svg";
import "./index.scss";
import { RxCross2 } from "react-icons/rx";
import {
    currencySymbol,
    findConstantLabel,
    numberWithCommas,
    priceTagFormatter,
} from "../../../constants/utils";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import ConfirmationModal from "../ConfirmationModal";
import {
    LightBoxProps,
    ModifiedTableDataProps,
    ProductItemsProps,
} from "./interface";
import { useTableCalculation } from "./hook/useTableCalculation";
import LightBoxDetail from "./component/LightboxDetail";
import { useFindGstType } from "./hook/useFindGSTType";

const { Button, Image, Table, CustomImages } = atoms;

const SidePopUp = (props: LightBoxProps) => {
    const { getTableValue, getTotalValue,getTotalAmount } = useTableCalculation()
    const { showGstField } = useFindGstType()
    // const supplierGstType = props?.isViewData?.supplier?.gst_type;
    const supplierGstType:boolean = showGstField(props?.isViewData);

    const PdfRef = useRef(null);
    const region_code: number =
        props?.isViewData?.physical_store?.region || constant.STORE_REGION.INDIA;
    const handleUpdateStatus = (status: number) => {
        props.updateVerificationStatus(props?.isViewData?.id || "", status);
        props.onHide();
    };

    const [productDataTable, setProductDataTable] = useState<any>();
    const [inventoryConfirmation, setInventoryConfirmation] =
        useState<boolean>(false);
    const [rejectConfirmation, setRejectConfirmation] = useState<boolean>(false);
    useEffect(() => {
        if (props.isViewData?.product_details) {
            const tempProductData = [...props.isViewData?.product_details];
            if (tempProductData?.length > 0) {
                tempProductData.push({});
            }
            setProductDataTable(tempProductData);
        }
    }, [props.isViewData?.product_details]);

    const handlePrint = useReactToPrint({
        content: () => PdfRef.current,
        documentTitle:
            "Inventory" + Math.floor(100000 + Math.random() * 900000).toString(),
    });

    const getNestedData = (
        data: ProductItemsProps[],
        type: string,
        isContactLens: boolean
    ): number => {
        let modifiedData = modifiedTableData({ data: data, isContactLens });
        let temp = 0;
        modifiedData &&
            modifiedData.map((value, index: number) => {
                if (type === "quantity") {
                    temp += value[type] || 0;
                } else {
                    if (value?.product?.product_srp) {
                        temp += value?.product[type];
                    }
                }
            });
        return temp;
    };
    const columns = [
        {
            name: "Product ID",
            selector: (row: ProductItemsProps) =>
                row?.product?.product_id_display || "",
            minWidth: "130px",
        },
        {
            name: "Product Type",
            selector: (row: ProductItemsProps) =>
                !row?.product?.product_type ? (
                    <span className="fw-600 fs-14">Total</span>
                ) : (
                    row?.product?.product_type?.name
                ),
            sortable: true,
            minWidth: "110px",
        },
        {
            name: "Product Image",
            cell: (row: ProductItemsProps) =>
                row?.product?.images?.length > 0 ? (
                    <CustomImages
                        src={row?.product?.images?.length > 0 && row?.product?.images[0]}
                    />
                ) : (
                    ""
                ),
            center: true,
            minWidth: "120px",
        },
        {
            name: "Brand",
            selector: (row: ProductItemsProps) =>
                row?.product?.brand?.brand_name || "",
            minWidth: "80px",
        },
        {
            name: "Model Number",
            selector: (row: ProductItemsProps) => row?.product?.modal_number || "",
            minWidth: "90px",
        },
        {
            name: "Brand Color Code",
            selector: (row: ProductItemsProps) =>
                row?.product?.brand_color_code || "",
            minWidth: "100px",
        },
        {
            name: "Glass Size/Power",
            selector: (row: ProductItemsProps) => row?.product?.glass_size || "",
            minWidth: "80px",
        },
        {
            name: `SRP (${currencySymbol(region_code)})`,
            selector: (row: ProductItemsProps) =>
                !row?.product ? (
                    <span className="fw-600 fs-14">
                        {priceTagFormatter(
                            totalSRP(
                                props?.isViewData?.product_details as Array<any>,
                                false,
                                false
                            ),
                            region_code
                        )}
                    </span>
                ) : row?.product?.product_srp ? (
                    priceTagFormatter(row?.product.product_srp, region_code)
                ) : (
                    ""
                ),
            minWidth: "90px",
        },

        supplierGstType && {
            name: `GST (%)`,
            selector: (row: ProductItemsProps) => row?.product ? row?.product?.product_type?.gst_percentage : "",
        },
        {
            name: `Unit Cost Amount (${currencySymbol(region_code)})`,
            selector: (row: ProductItemsProps) => row?.product ? priceTagFormatter(getTableValue(row,'Unit Cost Amount'), region_code) : "",
        },
        {
            name: `Discount Amount`,
            selector: (row: ProductItemsProps) => row?.product ? priceTagFormatter(getTableValue(row, 'Discount Amount'),region_code) : "",
        },
        {
            name: "QTY",
            selector: (row: ProductItemsProps) =>
                !row?.product ? (
                    <span className="fw-600 fs-14">
                        {getNestedData(
                            props?.isViewData?.product_details as Array<any>,
                            "quantity",
                            false
                        )}
                    </span>
                ) : (
                    row?.quantity
                ),
            minWidth: "55px",
        },
        {
            name: `Amount`,
            selector: (row: ProductItemsProps) => row?.product ? priceTagFormatter(getTableValue(row, 'Amount'),region_code) : <span className="fw-600 fs-14">
                {priceTagFormatter(getTotalValue(props?.isViewData?.product_details as Array<any>, 'Amount', false),region_code)}
            </span>,
            minWidth: "110px",
        },
        supplierGstType &&  {
            name: `Total GST`,
            minWidth: "110px",
            selector: (row: ProductItemsProps) => row?.product ? 
                priceTagFormatter(getTableValue(row, 'Total GST'),region_code) : 
                    <span className="fw-600 fs-14">{
                        priceTagFormatter(getTotalValue(props?.isViewData?.product_details as Array<any>, 'Total GST', false),region_code)
                    }
                </span>,
        },
        {
            name: "Total Amount",
            selector: (row: ProductItemsProps) =>
                !row?.product ? (
                    <span className="fw-600 fs-14">
                        {priceTagFormatter(getTotalValue(props?.isViewData?.product_details as Array<any>, 'Total Amount', false,supplierGstType),region_code)}
                    </span>
                ) : (
                    priceTagFormatter(getTableValue(row, 'Total Amount', supplierGstType),region_code)
                ),
            minWidth: "110px",
        },
        {
            name: "Verification Status",
            selector: (row: any) =>
                row?.product?.verification_status ===
                    constant.VERIFICATION_STATUS.PENDING ? (
                    <div className="background-light-yellow border-product-radius">
                        <p className="color-yellow m-1 p-1">{"Pending"}</p>
                    </div>
                ) : row?.product?.verification_status ===
                    constant.VERIFICATION_STATUS.VERIFIED ? (
                    <div className="background-light-green border-product-radius">
                        <p className="color-green m-1 p-1">{"Approved"}</p>
                    </div>
                ) : row?.product?.verification_status ===
                    constant.VERIFICATION_STATUS.REWORK ? (
                    <div className="background-light-red border-product-radius">
                        <p className="color-red m-1 p-1">{"Rework"}</p>
                    </div>
                ) : (
                    ""
                ),
            minWidth: "120px",
        },
    ]?.filter(Boolean);

    const contactLensColumns = [
        {
            name: "Product ID",
            selector: (row: ProductItemsProps) =>
                row?.product?.product_id_display || "",
            minWidth: "130px",
        },
        {
            name: "Product Type",
            selector: (row: ProductItemsProps) =>
                !row?.product?.product_type ? (
                    <span className="fw-600 fs-14">Total</span>
                ) : (
                    row?.product?.product_type?.name
                ),
            sortable: true,
            minWidth: "110px",
        },
        {
            name: "Product Image",
            cell: (row: ProductItemsProps) =>
                row?.product?.images?.length > 0 ? (
                    <CustomImages
                        src={row?.product?.images?.length > 0 && row?.product?.images[0]}
                    />
                ) : (
                    ""
                ),
            center: true,
            minWidth: "120px",
        },
        {
            name: "Brand",
            selector: (row: ProductItemsProps) =>
                row?.product?.brand?.brand_name || "",
            minWidth: "80px",
        },
        {
            name: "Model Number",
            selector: (row: ProductItemsProps) => row?.product?.modal_number || "",
            minWidth: "90px",
        },
        {
            name: "Lens Type",
            selector: (row: ProductItemsProps) => row?.product?.lens_type || "",
            minWidth: "100px",
        },
        {
            name: "Period Use",
            selector: (row: ProductItemsProps) => row?.product?.period_use || "",
            minWidth: "80px",
        },
        {
            name: `SRP (${currencySymbol(region_code)})`,
            selector: (row: ProductItemsProps) =>
                !row?.product ? (
                    <span className="fw-600 fs-14">
                        {priceTagFormatter(
                            totalSRP(
                                props?.isViewData?.product_details as Array<any>,
                                false,
                                true
                            ),
                            region_code
                        )}
                    </span>
                ) : row?.product?.product_srp ? (
                    priceTagFormatter(row?.product.product_srp, region_code)
                ) : (
                    ""
                ),
            minWidth: "90px",
        },
        supplierGstType &&  {
            name: `GST (%)`,
            selector: (row: ProductItemsProps) => row?.product ? row?.product?.product_type?.gst_percentage : "",
        },
        {
            name: `Unit Cost Amount (${currencySymbol(region_code)})`,
            selector: (row: ProductItemsProps) => row?.product ? numberWithCommas(Number(row.cost_amount)) : "",
        },
        {
            name: `Discount Amount`,
            selector: (row: ProductItemsProps) => row?.product ? getTableValue(row, 'Discount Amount') : "",
        },
        {
            name: "QTY",
            selector: (row: ProductItemsProps) =>
                !row?.product ? (
                    <span className="fw-600 fs-14">
                        {getNestedData(
                            props?.isViewData?.product_details as Array<any>,
                            "quantity",
                            true
                        )}
                    </span>
                ) : (
                    row?.quantity
                ),
            minWidth: "55px",
        },
        {
            name: `Amount`,
            selector: (row: ProductItemsProps) => row?.product ? priceTagFormatter(getTableValue(row, 'Amount'),region_code) : <span className="fw-600 fs-14">
                {priceTagFormatter(getTotalValue(props?.isViewData?.product_details as Array<any>, 'Amount', true),region_code)}
            </span>,
            minWidth: "110px",
        },
        supplierGstType &&  {
            name: `Total GST`,
            minWidth: "110px",
            selector: (row: ProductItemsProps) => row?.product ? 
                priceTagFormatter(getTableValue(row, 'Total GST'),region_code) : 
                    <span className="fw-600 fs-14">{
                        priceTagFormatter(getTotalValue(props?.isViewData?.product_details as Array<any>, 'Total GST', true),region_code)
                    }
                </span>,
        },
        {
            name: "Total Amount",
            selector: (row: ProductItemsProps) =>
                !row?.product ? (
                    <span className="fw-600 fs-14">
                        {priceTagFormatter(getTotalValue(props?.isViewData?.product_details as Array<any>, 'Total Amount', true,supplierGstType),region_code)}
                    </span>
                ) : (
                    priceTagFormatter(getTableValue(row, 'Total Amount', supplierGstType),region_code)
                ),
            minWidth: "110px",
        },
        {
            name: "Verification Status",
            selector: (row: ProductItemsProps) =>
                row?.product?.verification_status ===
                    constant.VERIFICATION_STATUS.PENDING ? (
                    <div className="background-light-yellow border-product-radius">
                        <p className="color-yellow m-1 p-1">{"Pending"}</p>
                    </div>
                ) : row?.product?.verification_status ===
                    constant.VERIFICATION_STATUS.VERIFIED ? (
                    <div className="background-light-green border-product-radius">
                        <p className="color-green m-1 p-1">{"Approved"}</p>
                    </div>
                ) : row?.product?.verification_status ===
                    constant.VERIFICATION_STATUS.REWORK ? (
                    <div className="background-light-red border-product-radius">
                        <p className="color-red m-1 p-1">{"Rework"}</p>
                    </div>
                ) : (
                    ""
                ),
            minWidth: "120px",
        },
    ]?.filter(Boolean);

    const modifiedTableData = ({
        data,
        isContactLens,
    }: ModifiedTableDataProps) => {
        let filterCondition = (items: ProductItemsProps) =>
            items?.product?.is_contact_lens === isContactLens;
        return data?.filter(filterCondition).length > 0
            ? [...data?.filter(filterCondition), {}]
            : [];
    };

    const isShowModifiedTable = ({
        data,
        isContactLens,
    }: ModifiedTableDataProps): boolean => {
        return (
            data &&
            modifiedTableData({ data: data, isContactLens: isContactLens }).length > 0
        );
    };

    const totalSRP = (
        data: Array<any>,
        isTotalAmount: boolean,
        isContactLens: boolean
    ): number => {
        let modifiedData = modifiedTableData({ data: data, isContactLens });
        return modifiedData.reduce((total: number, item: any) => {
            const productSRP = !isTotalAmount
                ? item?.product?.product_srp
                : item?.total_price + (item?.gst_amount ?? 0);
            if (typeof productSRP === "number" && !isNaN(productSRP)) {
                return total + productSRP;
            }
            return total;
        }, 0);
    };

    const size = "297mm 210mm";

    const getPageMargins = () => {
        return `
      @page {
         margin-top: 10mm; 
         margin-right: 10mm; 
         margin-bottom:10mm; 
         margin-left: 10mm; 
         size: 297mm 210mm; !important
        } 

        div.page {
            page-break-after: always;
          }
         `;
    };

    // Call the function to get the CSS string
    const cssString = getPageMargins();

    // function to show the value in light box detail section
    const getComputedInvoiceValue = (data: any, region_code: number) =>
        priceTagFormatter(
            Number(getTotalValue(props?.isViewData?.product_details as Array<any>, 'Total Amount', false,supplierGstType)) +
           Number(getTotalValue(props?.isViewData?.product_details as Array<any>, 'Total Amount', true,supplierGstType)),
          region_code
        );
      
      const getSupplierDisplayName = (data: any) =>
        data?.local_supplier_name ||
        data?.supplier?.supplier_name ||
        "NA";
      
      const getSupplierGstOrCategory = (data: any, supplierGstType: boolean, region_code: number) =>
        supplierGstType 
          ? priceTagFormatter(data?.total_gst, region_code) || "NA"
          : data?.category
          ? findConstantLabel(constant.INVOICE_CATEGORY, data?.category as number)
          : "NA";
      
    //end

    //light box detail section
    const lightBoxDetailRows:any = [
        {
          labels: ["Physical Store", "Supplier Invoice No", "Supplier Invoice Date"],
          values: [
            props?.isViewData?.physical_store?.store_name || "NA",
            props?.isViewData?.supplier_invoice_number || "NA",
            props?.isViewData?.supplier_invoice_date
              ? moment(props?.isViewData.supplier_invoice_date).format("DD-MM-YYYY")
              : "NA",
          ],
        },
        {
          labels: ["Supplier Details", "Created Date", "Actual Invoice Value"],
          values: [
            getSupplierDisplayName(props?.isViewData),
            props?.isViewData?.createdAt
              ? moment(props?.isViewData.createdAt).format("DD-MM-YYYY")
              : "NA",
            priceTagFormatter(props?.isViewData?.actual_invoice, region_code),
          ],
        },
        {
          labels: [
            "Computed Invoice Value",
            "Total Product Case",
            supplierGstType ? "Total GST" : "Category",
          ],
          values: [
            getComputedInvoiceValue(props?.isViewData, region_code),
            props?.isViewData?.total_product_case || "NA",
            getSupplierGstOrCategory(props?.isViewData, supplierGstType, region_code),
          ],
        },
      ];

    //end

    return (
        <Modal
            className="rounded-0"
            isOpen={props.show}
            wrapClassName="modal-right"
        >
            <ModalHeader className="d-flex border-0 position-relative">
                {/* <div className="mt-4 fs-24 fw-600">{props.header}</div> */}
                <div className="mt-4 fs-24 fw-600 mb-0">Inventory</div>
                <div
                    className="position-absolute py-1 px-2"
                    style={{
                        top: "15%",
                        right: "3%",
                        backgroundColor: "transparent",
                        border: "1px solid #222",
                        borderRadius: "50%",
                        cursor: "pointer",
                    }}
                    onClick={() => props.onHide()}
                >
                    <RxCross2 style={{ color: "#222" }} />
                </div>
            </ModalHeader>
            <ModalBody className="pt-md-0">
                <div className="d-flex justify-content-between">
                    <div>
                        <div className=" d-flex gap-3 align-items-center mb-4">
                            <h2 className="mb-0 fs-18 fw-700 secondary-color ">
                                Invoice Addition ID:
                            </h2>
                            <div className="d-flex justify-content-around align-items-center py-2 add-product-custom-div cursor-pointer">
                                <h2 className="mb-0 fs-16 fw-600 secondary-color">
                                    {props?.isViewData?.invoice_id_display}
                                </h2>
                                <div className="">
                                    <Image
                                        src={CopyIcon}
                                        onClick={() =>
                                            navigator.clipboard.writeText(
                                                props?.isViewData?.invoice_id_display as string
                                            )
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <Button isDisabled={!props.isViewData} onClick={handlePrint}>
                            Download PDF
                        </Button>
                    </div>
                </div>
                <hr className="mt-3" style={{ border: "1px dashed #222" }} />
                <div className="printAbleComponent" ref={PdfRef}>
                    <style>{cssString}</style>
                    <LightBoxDetail rows={lightBoxDetailRows}/>
                  {supplierGstType &&  <>
                    <div className="row mt-4">
                        <div className="col-4  fs-16 fw-800 secondary-color">Category</div>
                    </div>
                    <div className="row">
                        <div className="col-4 fs-16 fw-400 secondary-color">
                            {props?.isViewData?.category
                                ? findConstantLabel(
                                    constant.INVOICE_CATEGORY,
                                    props?.isViewData?.category as number
                                )
                                : "NA"}
                        </div>
                    </div>
                    </>}

                    {isShowModifiedTable({
                        data: productDataTable,
                        isContactLens: false,
                    }) && (
                            <div>
                                <Table
                                    columns={columns}
                                    data={modifiedTableData({
                                        data: productDataTable,
                                        isContactLens: false,
                                    })}
                                    className="inventory-product-border"
                                    isStyledDataTable={true}
                                />
                            </div>
                        )}
                    {isShowModifiedTable({
                        data: productDataTable,
                        isContactLens: true,
                    }) && (
                            <div>
                                <Table
                                    columns={contactLensColumns}
                                    data={modifiedTableData({
                                        data: productDataTable,
                                        isContactLens: true,
                                    })}
                                    className="inventory-product-border"
                                    isStyledDataTable={true}
                                />
                            </div>
                        )}
                    <hr className="mt-5" style={{ border: "1px dashed #222" }} />
                    <div className="row mt-4">
                        <div className="col-4 fs-20 fw-600 secondary-color">Remarks</div>
                    </div>
                    <div className="row mt-4 add-inventory-custom-div">
                        <div className="col-4 fs-20 fw-600 secondary-color">
                            {props?.isViewData?.remark}
                        </div>
                    </div>
                </div>
            </ModalBody>

            {props?.isViewData?.verification_status ==
                constant.VERIFICATION_STATUS.PENDING && (
                    <ModalFooter
                        className="border-0 d-flex"
                        style={{ flexWrap: "inherit" }}
                    >
                        {props.isShowButton && (
                            <>
                                <Button
                                    className="fs-16 fw-500 reject-btn"
                                    onClick={() => setRejectConfirmation(!rejectConfirmation)}
                                >
                                    Reject
                                </Button>{" "}
                            </>
                        )}

                        <Button
                            className={`fs-16 fw-500 approve-btn ${!props.isShowButton && "w-100"
                                }`}
                            onClick={() => setInventoryConfirmation(!inventoryConfirmation)}
                        >
                            Approve
                        </Button>
                    </ModalFooter>
                )}

            {inventoryConfirmation && (
                <ConfirmationModal
                    show={inventoryConfirmation}
                    handleConfirmItem={() => {
                        handleUpdateStatus(constant.VERIFICATION_STATUS.VERIFIED);
                        setInventoryConfirmation(!inventoryConfirmation);
                    }}
                    onHide={() => setInventoryConfirmation(!inventoryConfirmation)}
                    message={"approve inventory"}
                />
            )}

            {rejectConfirmation && (
                <ConfirmationModal
                    show={rejectConfirmation}
                    handleConfirmItem={() => {
                        handleUpdateStatus(constant.VERIFICATION_STATUS.REWORK);
                        setRejectConfirmation(!rejectConfirmation);
                    }}
                    onHide={() => setRejectConfirmation(!rejectConfirmation)}
                    message={"reject"}
                />
            )}
        </Modal>
    );
};

export default SidePopUp;
